module.exports = __webpack_public_path__ + "way2go/static/config/logo_dark.png";